export const getInitials = (name = ""): string =>
  name
    .replace(/\s+/u, " ")
    .split(" ")
    .slice(0, 2)
    .map((v) => (v.length > 0 ? v[0].toUpperCase() : ""))
    .join("");
